export default __webpack_public_path__ + "static/media/Info Circle 1.db038261.svg";